export function Cases() {
  const cases = [
    {
      title: 'Tech Company Global Launch',
      client: 'Leading Chinese AI Company',
      category: 'Brand Film & Event Coverage',
      location: 'Silicon Valley, USA',
      image: 'https://static.readdy.ai/image/17d917f43abf2e0d5a0666d8ddfb2811/f8992f2000f6ab695ee8d9d4a81655ca.png',
      imagePosition: 'object-center',
      description: 'Comprehensive media coverage for a major product launch event, including multi-camera live streaming, promotional video production, and social media content creation.',
      results: ['10M+ Live Views', '50+ Media Outlets', '300% Engagement Increase']
    },
    {
      title: 'International Finance Summit',
      client: 'Global Investment Forum',
      category: 'Conference Media Services',
      location: 'London, UK',
      image: 'https://public.readdy.ai/ai/img_res/c67d820b9f735d57235d8c9ee9384ba2.jpg',
      imagePosition: 'object-top',
      description: 'Full-service media support for a three-day international summit, featuring simultaneous interpretation, multi-platform streaming, and post-event content production.',
      results: ['5,000+ Attendees', '20+ Languages', '48hrs Turnaround']
    },
    {
      title: 'E-commerce Brand Expansion',
      client: 'Fashion Retail Brand',
      category: 'Multilingual Marketing Videos',
      location: 'Paris & Milan',
      image: 'https://readdy.ai/api/search-image?query=High-end%20European%20fashion%20boutique%20interior%20with%20elegant%20minimalist%20design%20featuring%20white%20marble%20floors%20modern%20display%20fixtures%20soft%20natural%20window%20lighting%20and%20sophisticated%20retail%20atmosphere%20captured%20in%20realistic%20architectural%20photography%20style%20with%20clean%20aesthetic%20and%20professional%20composition&width=800&height=600&seq=case-real-003&orientation=landscape',
      imagePosition: 'object-top',
      description: 'Created a series of localized promotional videos for European markets, including French and Italian versions with cultural adaptation and local influencer collaborations.',
      results: ['200% Sales Growth', '15+ Markets', '5M+ Video Views']
    },
    {
      title: 'Corporate Documentary Series',
      client: 'Multinational Manufacturing Group',
      category: 'Brand Storytelling',
      location: 'Germany & Japan',
      image: 'https://readdy.ai/api/search-image?query=Modern%20advanced%20manufacturing%20facility%20interior%20with%20precision%20machinery%20and%20skilled%20workers%20in%20clean%20industrial%20environment%20featuring%20bright%20overhead%20lighting%20organized%20production%20floor%20high-tech%20equipment%20and%20professional%20industrial%20atmosphere%20captured%20in%20realistic%20documentary%20photography%20style%20with%20authentic%20workplace%20setting%20natural%20depth%20of%20field%20and%20cinematic%20composition%20showing%20real%20manufacturing%20operations&width=800&height=600&seq=case-real-004-v3&orientation=landscape',
      imagePosition: 'object-top',
      description: 'Produced a six-episode documentary series showcasing the company\'s global operations, innovation, and sustainability initiatives across multiple countries.',
      results: ['Industry Awards', 'Global Recognition', 'Brand Value +40%']
    },
    {
      title: 'Virtual Conference Platform',
      client: 'Education Technology Company',
      category: 'Live Streaming & Interactive Media',
      location: 'Singapore',
      image: 'https://static.readdy.ai/image/17d917f43abf2e0d5a0666d8ddfb2811/159f2965e25c53154680ac6652a60131.jpeg',
      imagePosition: 'object-top',
      description: 'Developed and executed a hybrid conference solution combining in-person and virtual attendance, with interactive features and real-time engagement tools.',
      results: ['10,000+ Participants', '95% Satisfaction', 'Zero Downtime']
    },
    {
      title: 'Tourism Destination Campaign',
      client: 'National Tourism Board',
      category: 'Destination Marketing',
      location: 'New Zealand',
      image: 'https://readdy.ai/api/search-image?query=Stunning%20New%20Zealand%20mountain%20landscape%20with%20pristine%20turquoise%20lake%20surrounded%20by%20snow-capped%20peaks%20and%20lush%20green%20valleys%20featuring%20dramatic%20natural%20scenery%20under%20clear%20blue%20sky%20captured%20in%20realistic%20landscape%20photography%20style%20with%20vibrant%20colors%20and%20breathtaking%20natural%20beauty&width=800&height=600&seq=case-real-006&orientation=landscape',
      imagePosition: 'object-top',
      description: 'Created a comprehensive video campaign targeting Asian markets, featuring stunning cinematography, local stories, and multilingual content for social media and broadcast.',
      results: ['50M+ Impressions', '8 Languages', 'Tourism +35%']
    }
  ];

  return (
    <section id="cases" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-100 rounded-full mb-4">
            <span className="text-blue-600 font-semibold text-sm">SUCCESS STORIES</span>
          </div>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            <strong>Global Projects</strong> That Made Impact
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover how we've helped brands and organizations achieve their global communication goals through innovative media solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {cases.map((caseItem, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={caseItem.image}
                  alt={caseItem.title}
                  className={`w-full h-full object-cover ${caseItem.imagePosition || 'object-top'} group-hover:scale-110 transition-transform duration-500`}
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full text-sm font-semibold text-gray-900">
                    {caseItem.category}
                  </span>
                </div>
              </div>

              <div className="p-8">
                <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">
                  <i className="ri-map-pin-line"></i>
                  <span>{caseItem.location}</span>
                </div>

                <h4 className="text-2xl font-bold text-gray-900 mb-2">
                  <strong>{caseItem.title}</strong>
                </h4>
                
                <p className="text-blue-600 font-semibold mb-4">{caseItem.client}</p>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {caseItem.description}
                </p>

                <div className="flex flex-wrap gap-3">
                  {caseItem.results.map((result, idx) => (
                    <div key={idx} className="px-3 py-1 bg-blue-50 rounded-full">
                      <span className="text-sm font-semibold text-blue-600">{result}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}